import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { ReportsView } from 'components/views/reports-view';
import { reportsSearchSchema } from 'src/modules/reports/schemas/reports-search.schema';

/**
 * File-based route entry for the native reports page nested under Calls.
 */
export const Route = createFileRoute('/calls/reports')({
  component: CallsReportsComponent,
  validateSearch: (search) => reportsSearchSchema.parse(search),
});

function CallsReportsComponent() {
  return (
    <AuthenticateRoute>
      <ReportsView />
    </AuthenticateRoute>
  );
}
